<template>
  <el-dialog
    width="30%"
    :title="!dataForm.bonusId ? '新增' : '奖金详情'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
      :rules="dataRule"
    >
      <el-form-item label="年月" prop="yearMonth">
        <el-date-picker
          @change="getDataList"
          v-model="dataForm.yearMonth"
          :picker-options="pickerOptions0"
          disabled
          type="month"
          placeholder="选择年月"
          value-format="yyyy-MM"
          style="width: 100%;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="姓名" prop="realName" v-if="!dataForm.bonusId">
        <el-select v-model="dataForm.realName" placeholder="请选择" style="width:100%;" @change="select" :disabled="dataForm.yearMonth?false:true" clearable>
          <el-option
            v-for="item in member"
            :key="item.userId"
            :label="item.realName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="realName" v-if="dataForm.bonusId">
        <el-input v-model="dataForm.realName" disabled></el-input>
      </el-form-item>
      <el-form-item label="考勤" prop="kaoqinDate">
        <el-input v-model="dataForm.kaoqinDate"  disabled></el-input>
      </el-form-item>
      <el-form-item label="能量" prop="energy">
        <el-input v-model="dataForm.energy"  disabled></el-input>
      </el-form-item>
      <el-form-item label="加班时长" prop="overtimeMin">
        <el-input v-model="dataForm.overtimeMin"  disabled></el-input>
      </el-form-item>
      <el-form-item label="月度考勤" prop="reviewMonthlyMin">
        <el-input v-model="dataForm.reviewMonthlyMin"  disabled></el-input>
      </el-form-item>
      <!-- <el-form-item label="学习技能" prop="learnSkill">
        <el-input v-model="dataForm.learnSkill"  disabled></el-input>
      </el-form-item> -->
      <el-form-item label="总分" prop="totalProints">
        <el-input v-model="dataForm.totalProints"  disabled></el-input>
      </el-form-item>
      <el-form-item label="奖金" prop="bonus">
        <el-input v-model="dataForm.bonus"  disabled></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { userListData } from "@/api/list";
import { bonusAdd, bonusUpdate } from "../api";
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        energy: "",
        kaoqinDate: "",
        overtimeMin: "",
        reviewMonthlyMin: "",
        learnSkill: "",
        totalProints: "",
        bonus: "",
        userId: "",
        realName: "",
        yearMonth: "",
        realName: "",
        bonusId: ''
      },
      member: [],
      dataRule: {
        realName: [
          { required: true, message: '员工姓名不能为空', trigger: 'blur' }
        ],
        kaoqinDate: [
          { required: true, message: '考勤不能为空', trigger: 'blur' }
        ],
        energy: [
          { required: true, message: '能量不能为空', trigger: 'blur' }
        ],
        overtimeMin: [
          { required: true, message: '加班时长不能为空', trigger: 'blur' }
        ],
        reviewMonthlyMin: [
          { required: true, message: '月度考勤不能为空', trigger: 'blur' }
        ],
        learnSkill: [
          { required: true, message: '学习技能不能为空', trigger: 'blur' }
        ],
        bonus: [
          { required: true, message: '奖金不能为空', trigger: 'blur' }
        ],
        yearMonth: [
          { required: true, message: '年月不能为空', trigger: 'blur' }
        ],
        totalProints: [
          { required: true, message: '总分不能为空', trigger: 'blur' }
        ]
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },

    };
  },
  computed: {
    userTeamId: {
        get () { return this.$store.state.user.teamId }
      }
  },
  mounted() {
  },
  methods: {
    init(data) {
      this.dataForm.bonusId = data?data.bonusId : '';
      this.visible = true;
      this.$nextTick(() => {
        if (data) {
          this.dataForm.energy = data.energy
          this.dataForm.kaoqinDate = data.kaoqinDate
          this.dataForm.overtimeMin = data.overtimeMin
          this.dataForm.reviewMonthlyMin = data.reviewMonthlyMin
          this.dataForm.learnSkill = data.learnSkill
          this.dataForm.totalProints = data.totalProints
          this.dataForm.bonus = data.bonus
          this.dataForm.userId = data.userId
          this.dataForm.realName = data.realName
          this.dataForm.yearMonth = data.yearMonth
          // this.$http({
          //   url: this.$http.adornUrl(
          //     `/generator/sysdistrict/info/${this.dataForm.districtId}`
          //   ),
          //   method: "get",
          //   params: this.$http.adornParams(),
          // }).then(({ data }) => {
          //   if (data && data.code === 0) {
          //     this.dataForm.districtName = data.sysDistrict.districtName;
          //     this.dataForm.companyCode = data.sysDistrict.companyCode;
          //     this.dataForm.remark = data.sysDistrict.remark;
          //     this.dataForm.createUserId = data.sysDistrict.createUserId;
          //     this.dataForm.createTime = data.sysDistrict.createTime;
          //   }
          // });
        }else {
          this.dataForm = {};
        }
      });
    },
    // 获取员工列表
    getDataList(value) {
      userListData({
          yearMonth: value
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.member = data.users;
        } else {
          this.member = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 获取选择人的userId
    select(value) {
      this.dataForm.userId = value;
      this.member.forEach(item => {
        if(item.userId == value){
          this.dataForm.realName = item.realName
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let data = {
            energy: Number(this.dataForm.energy),
            kaoqinDate: Number(this.dataForm.kaoqinDate),
            overtimeMin: Number(this.dataForm.overtimeMin),
            reviewMonthlyMin: Number(this.dataForm.reviewMonthlyMin),
            learnSkill: this.dataForm.learnSkill,
            totalProints: Number(this.dataForm.totalProints),
            bonus: Number(this.dataForm.bonus),
            userId: Number(this.dataForm.userId),
            realName: this.dataForm.realName,
            yearMonth: this.dataForm.yearMonth, 
          };
          if(!this.dataForm.bonusId){
            bonusAdd(data).then( data => {
              if (data && data.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 500,
                  onClose: () => {
                    this.visible = false;
                    this.$emit("refreshDataList");
                  },
                });
              } else {
                this.$message.error(data.msg);
              }
            });
          } else {
            bonusUpdate(data).then( data => {
              if (data && data.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 500,
                  onClose: () => {
                    this.visible = false;
                    this.$emit("refreshDataList");
                  },
                });
              } else {
                this.$message.error(data.msg);
              }
            });
          }
          
        }
      });
    },
  },
};
</script>
